import { render, staticRenderFns } from "./create-org-admin.vue?vue&type=template&id=94d3ab68&scoped=true"
import script from "./create-org-admin.vue?vue&type=script&lang=js"
export * from "./create-org-admin.vue?vue&type=script&lang=js"
import style0 from "./create-org-admin.vue?vue&type=style&index=0&id=94d3ab68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d3ab68",
  null
  
)

export default component.exports